import { PresellContentModal } from '@/modules/common/components/presell-content-modal';
import { SellContentModal } from '@/modules/common/components/sell-content-modal';
import {
  BestPriceBuyerItem,
  getBestMarketPricesTabFx,
  IBestPriceBagItem,
} from '@/modules/mixing/store/analytical-mixing.store';
import { $selectedRecipeStore, setMarkeredMixes } from '@/modules/mixing/store/recipes.store';
import { Modal } from 'antd';
import { useStore } from 'effector-react';
import styles from './index.module.sass';
import { createOfferFoo } from '@@/common/utils/create-offer.function';

export const ActionModal = ({
  viewPresellWarning,
  setModalOpen,
  setModalViewOnly,
  modalOpen,
  actionState,
  price_after_moisture_mod,
  price_before_moisture_mod,
  offer,
  data,
  TARGET_MOISTURE,
  modalViewOnly,
  setActionState,
  moistureChangesDensity,
  setActiveTab,
  setViewPresellWarning,
}: {
  viewPresellWarning: boolean;
  setViewPresellWarning: (val: boolean) => void;
  setModalOpen: (val: boolean) => void;
  setModalViewOnly: (val: boolean) => void;
  modalOpen: boolean;
  actionState: "drain" | "hydrate" | null;
  price_after_moisture_mod: number;
  price_before_moisture_mod: number;
  offer?: BestPriceBuyerItem;
  data: IBestPriceBagItem;
  TARGET_MOISTURE: number;
  modalViewOnly: boolean;
  setActionState: (val: "drain" | "hydrate" | null) => void;
  moistureChangesDensity: boolean;
  setActiveTab: (val: number) => void;
}) => {
  const activeWarehouse = useStore($selectedRecipeStore);
  return (
    <Modal
      open={modalOpen}
      onCancel={() => {
        setModalOpen(false);
        setModalViewOnly(false);
        setViewPresellWarning(false);
        //setActionState(null);
      }}
      centered
      footer={null}
      rootClassName={styles.confirmModal}
      width={actionState === 'hydrate' ? 1024 : 880}
    >
      {viewPresellWarning === true ? (
        <PresellContentModal
          action={async () => {
            if (offer && price_after_moisture_mod === price_before_moisture_mod) {
              await createOfferFoo({
                action:
                  TARGET_MOISTURE === +data.values.humidity
                    ? null
                    : TARGET_MOISTURE > +data.values.humidity
                    ? 'hydrate'
                    : 'drain',
                weight_gain_tons: data.weight_gain_tons,
                price: offer.price_per_ton,
                weight: data.weight,
                sleeveData: data,
                onCancel: () => {
                  setModalViewOnly(false);
                  setModalOpen(false);
                  setActionState(null);
                },
                offer,
                warehouseId: Number(activeWarehouse?.id),
                additionalData: {
                  mix_id: null,
                  mixing_profit: null,
                  price_logistic: data.freight_cost_after_moisture_mod,
                  initial_price_logistic: offer.freight_price,
                  price_netto: offer.netto,
                  price_all: offer.price_all,
                  is_remnants: false,
                  action_place: null,
                },
                initial_weight_gain_tons: data.weight_gain_tons,
              });
              await getBestMarketPricesTabFx({
                trade: true,
                moistureChangesDensity,
              });
              //await fetchWarehousesForMixingDataFx({} as any);
              return;
            }
            setActionState(
              TARGET_MOISTURE < +data.values.humidity ? 'drain' : 'hydrate',
            );
            setViewPresellWarning(false);
          }}
          mixAction={async () => {
            setMarkeredMixes(data.mixes.map((item) => +Object.entries(item)[0][0]));
            setActiveTab(1);
          }}
          mixes={data.mixes}
        />
      ) : (
        <SellContentModal
          onCancel={() => {
            setModalViewOnly(false);
            setModalOpen(false);
            //setActionState(null);
          }}
          sleeveData={data}
          offer={offer as BestPriceBuyerItem}
          action={actionState}
          modalViewOnly={modalViewOnly}
        />
      )}
    </Modal>
  );
};
